// /*
//  * Name: Scaffolding-WP
//  * Author: Craig Cooper
//  * Author URI: http://craigomatic.co.uk
//  * Description: A bare bones front-end framework for Wordpress
//  * Version: 0.1
//  */


sortby();

function sortby() {
	const $sorter = document.querySelector(".ordering__orderby");
	$sorter.addEventListener("change", (e) => {

		const $value = e.target.value;
		const $location = window.location.href;
		const $urlStart = $location.split("?")[0];
		// const regex = /.*(?<=s=)(.*?)(?=&).*/gm;
		// const subst = "$1";

		const $term = $location.replace(/.*(?<=s=)(.*?)(?=&).*/, "$1");
		let $url = $location;

		if ($location.indexOf("/shop/") > -1) {
			$url = `${$urlStart}?orderby=${$value}`;
		} else {
			$url = `${$urlStart}?orderby=${$value}&paged=1&s=${$term}&post_type=product`;
		}
		window.location = $url;
	});
}